import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../global/default-button/default-button';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../../global/modal/common/common-close-modal-buttons';
import { DELETE_TEXT } from '../../../../../../constants/common-labels.constants';

interface IProps {
    deleteHandler: () => void;
}

const DeleteZoomMeetingButton = (props: IProps) => {
    const [showPopup, setShowPopup] = useState<boolean>(false);

    const showDeletePopup = () => {
        setShowPopup(true);
    };

    const confirmDelete = () => {
        props.deleteHandler();
        setShowPopup(false);
    };

    const closeDeletePopup = () => {
        setShowPopup(false);
    };

    return (
        <div className='delete-button'>
            <DefaultButton
                text={
                    <FormattedMessage {...DELETE_TEXT} />
                }
                modifier='slim'
                onClick={showDeletePopup}
            />
            {showPopup && <CommonModal
                isOpen={showPopup}
                onRequestClose={closeDeletePopup}
                supressRenderingCrossIcon={true}
                footer={
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultButton
                            modifier={['fat', 'confirm-warn']}
                            text={
                                <FormattedMessage
                                    id='oe.meeting.meetingDelete'
                                    defaultMessage='Delete Meeting'
                                    description='Label text'
                                />
                            }
                            onClick={confirmDelete}
                        />
                        <DefaultCloseModalButton />
                    </div>
                }
            >
                <div className='alert-body'>
                    <span className='alert-message'>
                        {
                            <>
                                <FormattedMessage
                                    id='oe.common.confirmMessageStart'
                                    defaultMessage='Are you sure you want to '
                                    description='Label text'
                                />
                                <span className='alert-message--danger'>
                                    <FormattedMessage
                                        id='oe.meeting.delete'
                                        defaultMessage='delete this meeting'
                                        description='Label text'
                                    />
                                </span>
                                ?
                            </>
                        }
                    </span>
                </div>
            </CommonModal>}
        </div>
    );
};

export { DeleteZoomMeetingButton };
